<form method="put" action="" enctype="multipart/form-data">
  <div class="d-flex">
    <div>
      <dx-text-area [height]="150" [maxLength]="2500" [(value)]="description" class="description mb-1"></dx-text-area>
      <dx-button text="{{ 'SEND_CLARIFICATION' | translate }}" (onClick)="sendClarification()" class="btn" icon="mdi mdi-send"></dx-button>
    </div>
    <div class="px-2">
      <div class="file-upload">
        <dx-file-uploader
          selectButtonText="{{ 'SELECT_FILE' | translate }}"
          labelText=""
          [multiple]="true"
          [maxFileSize]="5000000"
          [allowedFileExtensions]="['.doc', '.docx', '.xls', '.xlsx', '.pdf', '.jpg', '.jpeg', '.gif', '.png', '.txt']"
          uploadMode="useButton"></dx-file-uploader>
      </div>
    </div>
  </div>
</form>
